const USE_GENERAL_ELEMENT = true;

const isDomElement = USE_GENERAL_ELEMENT ? (ancestor) => ancestor instanceof Element : (ancestor) => ancestor instanceof HTMLElement;

// noinspection JSUnusedGlobalSymbols
export default isDomElement;
